/* OXS Hero — cursor-follower red glow (respects reduced-motion) */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hero = document.getElementById('hero');
  const glow = document.getElementById('heroGlow');
  if (hero && glow && !reduceMotion) {
    let px = 0, py = 0, ticking = false;
    hero.addEventListener('mousemove', (e) => {
      const r = hero.getBoundingClientRect();
      px = e.clientX - r.left;
      py = e.clientY - r.top;
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(() => {
          glow.style.left = px + 'px';
          glow.style.top = py + 'px';
          ticking = false;
        });
      }
    }, { passive: true });
  }
})();
